import { css } from '@emotion/css';

export const LockedPackagingIconStyles = {
  image: {
    marginLeft: '3px',
    marginBottom: '2px',
  },
};

export const LockedPackagingIconClasses = {
  container: css({
    pointerEvents: 'auto',
  }),
};
